import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef, signal } from '@angular/core';
import { BaseDashboardChartComponent, FilterOption } from '../base-dashboard-chart.component';
import { SelectModule } from 'primeng/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
 
@Component({
  selector: 'co-chart-card',
  imports: [SelectModule, FormsModule,ReactiveFormsModule,MultiSelectModule],
  templateUrl: './chart-card.component.html',
  styleUrl: './chart-card.component.css',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ChartCardComponent extends BaseDashboardChartComponent{
  chartFilters = input<FilterOption[][]>([]);
  private previousCompareBy: string | null = null;
 
  constructor(){
    super();
  }

  resetFilter(filterKey: string) 
  {
    const filter = this.filterOptions().find(f => f.key === filterKey);
    if (!filter || !filter.dropdownOptions?.length) return;
   
    const firstValue = filter.dropdownOptions[0].value;
 
    this.selectedFilters[filterKey] = filterKey === 'multiGroups' ? [firstValue] : firstValue;
 
    this.onDropdownChange(null, filterKey);
  }
 
  override onDropdownChange(event?: any, filterKey?: string) 
  {
    if (!filterKey) return;
 
    if (filterKey === 'multiGroups') {
      let multiValues = Array.isArray(event?.value) ? [...event.value] : [];
 
      if (multiValues.includes('All') && multiValues.length > 1) {
        multiValues = multiValues.filter(v => v !== 'All');
      }
 
      this.selectedFilters['multiGroups'] = multiValues;
    } else {
      this.selectedFilters[filterKey] = event?.value;
    }
 
    const currCompareBy = this.selectedFilters['compareBy'];
    if (currCompareBy && currCompareBy !== this.previousCompareBy) {
      
      const multiFilter = this.filterOptions().find(f => f.key === 'multiGroups');
      if (multiFilter?.dropdownOptions?.length) {
        this.selectedFilters['multiGroups'] = [multiFilter.dropdownOptions[0].value];
      }
      const filter = this.filterOptions().find(f => f.key ==='group');
      if(filter?.dropdownOptions?.length){
        this.selectedFilters['group'] = filter.dropdownOptions[0].value;
      }
      
      this.previousCompareBy = currCompareBy;
    }
 
    this.onFilterChange.emit(this.selectedFilters);
  }
 
}
 
export type TestResultType ="Hamed Rao" | "Chi Squared" | "Kolmogorov-Smirnov" | "Mann Whitney U" 